import { Document, Text, TopLevelBlock } from '@contentful/rich-text-types';

/* Removes empty paragraph at the end of a block, but only if is directly preceded by a list (order/unordered)
  Context:
  Contenful always appends a paragraph after every list, and it can not be deleted inside rich text editor
  our custom parsing option `GetProperParagraphOrSpace` converts every empty paragraph to <br>,
  that causes issues with unnecessary spacing after every list, especially at the end of a block
*/
export function removeEmptyParagraphAfterList(document: Document): Document {
  const contentLength = document.content?.length;
  if (!contentLength || contentLength < 2) return document;

  const secondToLastElement = document.content[contentLength - 2];
  const lastElement = document.content[contentLength - 1];
  if (!isList(secondToLastElement) || !isParagraph(lastElement) || !isParagraphEmpty(lastElement)) {
    return document;
  }

  const filteredContent = document.content.slice(0, -1);
  const filteredDocument = { ...document, content: filteredContent };

  return filteredDocument;
}

function isList(element: TopLevelBlock): boolean {
  return element.nodeType === 'unordered-list' || element.nodeType === 'ordered-list';
}

function isParagraph(element: TopLevelBlock): boolean {
  return element.nodeType === 'paragraph';
}

function isParagraphEmpty(element: TopLevelBlock): boolean {
  if (element.content[0]?.nodeType !== 'text') return false;

  // We know that this element is of type "Text", because we checked `nodeType == 'text'` above
  const paragraph = element.content[0] as Text;
  if (paragraph.value !== '') return false;

  return true;
}
